export const symptomCodeMap: Record<string, string> = {
  R51: "두통",
  R07: "흉통",
  R10: "복통",
  M54: "요통",
  O601: "분만진통",
  S06: "의식장애",
  T17: "기도이물",
  R060: "호흡곤란",
  R092: "호흡정지",
  I20: "심계항진",
  I21: "급성심근경색",
  I46: "심정지",
  R56: "경련",
  G40: "발작",
  R55: "실신",
  R11: "오심 / 구토",
  K59: "설사 / 변비",
  N39: "배뇨장애",
  R042: "객혈",
  K920: "토혈",
  R040: "비강출혈",
  N93: "질출혈",
  R05: "고열",
  T68: "저체온증",
  R42: "현기증",
  H81: "현훈",
  G83: "마비",
  R53: "전신쇠약",
  F01: "정신장애",

  // 임시
  CP010: "CP010",
  CP011: "CP011",
  CP012: "CP012",
};

export function convertChiefComplaints(codes: string[]): string {
  return codes
    .map((code) => symptomCodeMap[code])
    .filter(Boolean) // undefined 제거
    .join(", ");
}
